import { actionCreator } from '@ardoq/rxbeach';
import { GroupingRule } from '@ardoq/api-types';

export type SetGroupingRulesPayload = {
  groupingRules: GroupingRule[];
  transactionId?: string;
};

export const setGroupingRules = actionCreator<SetGroupingRulesPayload>(
  '[GroupingActions] SET_GROUPING_RULES'
);

export type AddGroupingRulesPayload = {
  groupingRules: GroupingRule[];
  /** If omitted, the existing transactionId on the stream is preserved. */
  transactionId?: string;
};

export const addGroupingRules = actionCreator<AddGroupingRulesPayload>(
  '[GroupingActions] ADD_GROUPING_RULES'
);

export const clearGroupingRules = actionCreator(
  '[GroupingActions] CLEAR_GROUPING_RULES'
);
